import React from 'react';
import { Link } from 'react-router-dom';

import { DeliveryContainer, DeliveryImage, DeliveryText } from './DeliveryStyles';

import imgDelivery from 'src/assets/uploads/delivery.png';

const Delivery = () => {
    return (
        <a href="https://api.whatsapp.com/message/PBDXCR3XANWVC1?autoload=1&app_absent=0" target="_blank">
            <DeliveryContainer>
                <DeliveryText>
                    Peça agora sua tele-entrega
                    <span>Tele entrega gratuita acima de R$70,00</span>
                    <span className='texto-juridico'>*Consultar bairros</span>
                </DeliveryText>
                <DeliveryImage src={imgDelivery} alt="Teleentrega"/>

                
            </DeliveryContainer>
        </a>
        
    )
}

export default Delivery;